import React from 'react'
import {Link} from "react-router-dom"
import {MoneyNav} from "../elements/MoneyNav"
import {getGlobalMoneyObject} from "../functions";

export class YearMoneyClass extends React.Component {

    render() {

        const {lang, dataYear, preYear, nextYear, pathBack} = this.props

        const dataNav = {
            pathBack: pathBack,
            isMain: false,
            isMoney: true,
            isSetting: false,
            isAddIncome: true,
            isAddCredit: false,
            isAddPurchase: true,
            isYearDetail: true,
            isSelectPeriod: true,
            currency: getGlobalMoneyObject()['currency']
        }

        const l = lang.lang

        let yearName = 'year', currency = '$', balance = '0'
        const months = [], dataMonths = [], calculation = new URLSearchParams(window.location.search).get('calculation')

        if (dataYear) {
            for (const field in dataYear) {
                yearName = field // название года
                currency = dataYear[field].currency // валюта
                balance = dataYear[field].balance // баланс
                const month = dataYear[field].months
                for (const m in month) {
                    months.push(m) // Массив имён месяцев
                    dataMonths.push(month[m]) // Массив объектов для каждого месяца года
                }
            }
        } else {
            return (
                <>
                    <MoneyNav dataNav={dataNav}/>
                </>
            )
        }

        return (
            <>
                <MoneyNav dataNav={dataNav}/>
                <div className={"mt-3 col col-sm-11 col-lg-12 col-xl-9 d-flex justify-content-center m-auto"}>
                    <div className={"row"}>
                        <div className={"col-sm-12"}>
                            <div className={"card mb-2"}>
                                <Link to={`/${lang.lang}/money/year/detail?year=${yearName}`} className={"text-decoration-none text-black"}>
                                    <div className={"card-body row col col-11"}>
                                        <div className={'col col-6 d-flex justify-content-end'}>
                                            <h5 className={"card-title m-auto"}>{yearName}</h5>
                                        </div>
                                        <div className={'col col-6 d-flex justify-content-start'}>
                                            <h5 className={"card-title m-auto"}>{lang.body.moneyPage.main.balance}&nbsp;{balance}</h5>
                                        </div>
                                    </div>
                                </Link>
                                <button className={'carousel-control-prev text-dark d-none'} type={'button'} disabled={true}>
                                    <i className={`fa-solid fa-chevron-left`}
                                       onClick={() => {
                                            window.location.replace(`/${l}/money/year?year=${preYear}&calculation=purchase_date`)
                                       }}/>
                                </button>
                                <button className={'carousel-control-next text-dark d-none'} type={'button'} disabled={true}>
                                    <i className={`fa-solid fa-chevron-right`}
                                       onClick={() => {
                                           window.location.replace(`/${l}/money/year?year=${nextYear}&calculation=purchase_date`)
                                       }}/>
                                </button>
                            </div>
                        </div>

                        {months.map((month, index) => {
                            const income = calculation === 'purchase_date' ? dataMonths[index]['incomesMonthTotalPurchase'] : dataMonths[index]['incomesMonthTotalPayment']
                            const expense = calculation === 'purchase_date' ? dataMonths[index]['expensesMonthTotalPurchase'] : dataMonths[index]['expensesMonthTotalPayment']
                            const balance = calculation === 'purchase_date' ? dataMonths[index]['balanceMonthPurchase'] : dataMonths[index]['balanceMonthPayment']
                            const m = {
                                id: month,
                                name: lang.body.moneyPage[month],
                                income: income,
                                expense: expense,
                                balance: balance
                            }
                            return (
                                <div className={"col-xs-4 col-sm-6 col-lg-4"} key={index}>
                                    <Link to={`/${lang.lang}/money/month/detail?year=${yearName}&month=${m.id}&calculation=${calculation}`} className={"text-decoration-none"}>
                                        <div className={"card mb-2"}>
                                            <div className={"card-body"}>
                                                <h5 className={"card-title border-bottom mb-3 pb-1"}>{m.name}</h5>
                                                {calculation === 'payment_date' && <div className={"d-flex m-0"}>
                                                    <div className={"p-1 w-100"}>{lang.body.moneyPage.main.totalIncome}</div>
                                                    <div className={"p-1 flex-shrink-1"}>
                                                        <strong className={"m-0 text-success"}>{m.income}</strong>
                                                        <strong className={"m-0 text-success"}>&nbsp;{currency}</strong>
                                                    </div>
                                                </div>}
                                                <div className={"d-flex m-0"}>
                                                    <div className={"p-1 w-100"}>{lang.body.moneyPage.main.totalExpense}</div>
                                                    <div className={"p-1 flex-shrink-1"}>
                                                        <strong className={"m-0 text-danger"}>{m.expense}</strong>
                                                        <strong className={"m-0 text-danger"}>&nbsp;{currency}</strong>
                                                    </div>
                                                </div>
                                                {calculation === 'payment_date' && <div className={"d-flex m-0"}>
                                                    <div className={"p-1 w-100"}>{lang.body.moneyPage.main.balance}</div>
                                                    <div className={"p-1 flex-shrink-1"}>
                                                        <strong className={"m-0 text-success"}>{m.balance}</strong>
                                                        <strong className={"m-0 text-success"}>&nbsp;{currency}</strong>
                                                    </div>
                                                </div>}
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            )
                        })}

                    </div>
                </div>
            </>
        )
    }
}
